module.exports = __webpack_public_path__ + "static/media/profile-placeholder.063ea4d0.svg";